import { Container } from "@fluidattacks/design";
import { styled } from "styled-components";

const StyledIndicators = styled(Container)`
  ${({ theme }): string => `
    display: grid;
    border-bottom: 1px solid ${theme.palette.gray[300]};
    gap: ${theme.spacing[1.25]};
    grid-template-columns: 1fr 1fr 1fr;
    width: 100%;

    #open-events {
      align-items: center;
      gap: ${theme.spacing[0.5]};

      > a {
        display: flex;
      }
    }
  `}
`;

export { StyledIndicators };
